import React from "react";
import ReadOnlyInput from "./ReadOnlyInput";
import InputWrapper from "./InputWrapper";
import { InputAdornment, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { DEFAULT_SIZE } from "../../../utils/constant";
import ReactInputMask from "react-input-mask";
import { useTheme } from "../../ContextStore/ThemeContext";
import PropTypes from "prop-types";

export default function EINField({
  name,
  mode,
  label,
  rules,
  control,
  isAddMode,
  fieldProps = {},
  size = DEFAULT_SIZE,
  startAdornment = null,
  ...rest
}) {
  const { theme } = useTheme();
  const { canView = true, canAdd = true, canEdit = true } = rest.permission || {};
  if (!canView || (isAddMode && !canAdd)) return null;

  const editModeAllowed = isAddMode ? canAdd : canEdit;
  if (mode === "read" || (mode === "edit" && !editModeAllowed)) {
    return <ReadOnlyInput name={name} label={label} rules={rules} size={size} type="text" {...rest} />;
  }

  return (
    <InputWrapper size={size}>
      <Controller
        control={control}
        name={name}
        rules={{
          ...(rules || {}),
          validate: {
            einFormat: value => {
              if (!value) return;
              const regex = /^\d{2}-\d{7}$/;
              return regex.test(value) || "Invalid EIN format. Use ##-#######";
            }
          }
        }}
        render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
          <ReactInputMask mask="99-9999999" maskChar="" value={value} onBlur={onBlur} onChange={onChange}>
            {() => (
              <TextField
                label={
                  <span>
                    {label}
                    {rules?.required && <span style={{ color: "red" }}> *</span>}
                  </span>
                }
                variant="outlined"
                fullWidth
                placeholder={label}
                InputProps={{
                  startAdornment: startAdornment ? <InputAdornment position="start">{startAdornment}</InputAdornment> : null
                }}
                InputLabelProps={{ shrink: true }}
                helperText={error?.message || null}
                error={!!error}
                {...fieldProps}
              />
            )}
          </ReactInputMask>
        )}
      />
    </InputWrapper>
  );
}

EINField.propTypes = {
  name: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(["read", "edit"]).isRequired,
  label: PropTypes.string.isRequired,
  rules: PropTypes.object.isRequired,
  control: PropTypes.object.isRequired,
  isAddMode: PropTypes.bool,
  handleReadValueClick: PropTypes.func,
  size: PropTypes.string,
  startAdornment: PropTypes.node,
  fieldProps: PropTypes.object,
  permission: PropTypes.shape({
    canView: PropTypes.bool,
    canAdd: PropTypes.bool,
    canEdit: PropTypes.bool
  })
};
